export default "__VITE_ASSET__Cxw3JQzv__"